import { createSlice } from "@reduxjs/toolkit";

// import referenceKind from "../mock/referenceKindTableMock";


const initialReferenceState = {
    listLoading: false,
    actionsLoading: false,
    allReferences: [],
    referenceKinds: [],
    serviceTypesTotalCount: 0,
    serviceTypes: [],
    receiptStatusesTotalCount: 0,
    receiptStatuses: [],  
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action"
};
  

const referenceSlice = createSlice({
    name: 'reference',
    initialState:initialReferenceState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        allReferencesFetched: (state, actions) => {
            const { references } = actions.payload;
            state.listLoading = false;
            state.error = null;
            state.allReferences = references;
        },
        referenceKindsFetched: (state, actions) => {
            const { refKinds } = actions.payload;
            state.listLoading = false;
            state.error = null;
            state.referenceKinds = refKinds;
        },
        // referencesByKindFetched: (state, action) => {
        //     const { totalCount, entities, kindId } = action.payload;
        //     state.listLoading = false;
        //     state.error = null;
        //     switch (kindId) {
        //         case referenceKind.SERVICE_TYPE:
        //         state.serviceTypes = entities;
        //         state.serviceTypesTotalCount = totalCount;              
        //         break;   
        //         case referenceKind.RECEIPT_STATUS:
        //             state.receiptStatuses = entities;
        //             state.receiptStatusesTotalCount = totalCount;              
        //             break;                      
        //         default:
        //         break;
        //     }
        // }
    }
});

export const {actions} = referenceSlice;
export const {reducer} = referenceSlice;